import { render, staticRenderFns } from "./BlogPost.vue?vue&type=template&id=74dc2c08&scoped=true"
import script from "./BlogPost.vue?vue&type=script&lang=js"
export * from "./BlogPost.vue?vue&type=script&lang=js"
import style0 from "./BlogPost.vue?vue&type=style&index=0&id=74dc2c08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74dc2c08",
  null
  
)

export default component.exports